import { Text } from "@/components/Primitives/Text/text"
import { cn } from "@/lib/utils/utils"

interface EmptyStateProps {
  message: string
  className?: string
}

export function EmptyState({ message, className }: EmptyStateProps) {
  return (
    <div className={cn("p-6 bg-neutral-50 rounded-lg mb-4", className)}>
      <Text variant="paragraph" className="text-neutral-500">
        {message}
      </Text>
    </div>
  )
}
